import axios from "axios";
import { API } from "./api.js";

const API_URL = API + "/configuration/";
//const API_URL = "http://localhost:3000/api/configuration/";
//const API_URL = "http://192.168.3.108:3000/api/configuration/";

const getCompanyURL = (dashboardName, companyName) => {
  return axios.post(API_URL + "companyURL", {
    dashboardName,
    companyName,
  });
};

const getLoginScreenStatus = (dashboardName) => {
  return axios.post(API_URL + "loginScreenStatus", {
    dashboardName,
  });
};

const getDashboardList = (projectname, dashboardtype) => {
  //console.log(projectname, dashboardtype)
  return axios.post(API_URL + "alldashboard", {
    projectname,
    dashboardtype,
  });
};

//Get count of records present in table
const getRowsCount = (dashboardName) => {
  return axios.post(API_URL + "count", {
    dashboardName,
  });
};

// get specific rows data, init record = page * rowsPerPage and number of record to fetch = rowsPerPage
const getRowsData = (dashboardName, offset, rowsPerPage) => {
  return axios.post(API_URL + "data", {
    dashboardName,
    offset,
    rowsPerPage,
  });
};

// Get all rows data present inside the table
const getAllRowsData = (dashboardName) => {
  return axios.post(API_URL + "all", {
    dashboardName,
  });
};

// Get all rows data present inside the table for specific value of the given column name
const getColumnData = (dashboardName, columnName, columnValue) => {
  return axios.post(API_URL + "columnData", {
    dashboardName,
    columnName,
    columnValue,
  });
};

// Get all field names of the specific table/collection
const getSchemaKeys = (dashboardName) => {
  return axios.post(API_URL + "schemaKeys", {
    dashboardName,
  });
};

// Save specific row data present inside the table
const updateRowData = (dashboardName, rowData, auditTrailData) => {
  return axios.post(API_URL + "update", {
    dashboardName,
    rowData,
    auditTrailData,
  });
};

// Save Toekn Data
const updateTokenData = (dashboardName, rowData, auditTrailData) => {
  return axios.post(API_URL + "updatetoken", {
    dashboardName,
    rowData,
    auditTrailData,
  });
};

// Create or Add document/record to existing collection/table
const createRow = (dashboardName, rowData) => {
  return axios.post(API_URL + "create", {
    dashboardName,
    rowData,
  });
};

// Delete specific document/record from existing collection/table
const deleteRow = (dashboardName, rowId) => {
  return axios.post(API_URL + "delete", {
    dashboardName,
    rowId,
  });
};

// Delete specific document/record from existing collection/table
const deleteCollection = (email, PWD, collectionName) => {
  return axios.post(API_URL + "deleteCollection", {
    email,
    PWD,
    collectionName,
  });
};

const insertCollection = (email, PWD, collectionName, dataArray) => {
  return axios.post(API_URL + "insertCollection", {
    email,
    PWD,
    collectionName,
    dataArray,
  });
};

// Delete many tags from Tableview, trendview or from reortview, if same tag get deleted from madbus taglist.
const deleteManyTag = (dashboardName, tagName) => {
  return axios.post(API_URL + "deletemanytag", {
    dashboardName,
    tagName,
  });
};

const getIPDetails = () => {
  return axios.post(API_URL + "getipdetails", {});
};

const changeIPDetails = (connectionName, address, netmask, gateway, dns) => {
  return axios.post(API_URL + "changeipdetails", {
    connectionName,
    address,
    netmask,
    gateway,
    dns,
  });
};

const getSysTime = () => {
  return axios.post(API_URL + "getsystime", {});
};

const changeSysTime = (hours, minutes, seconds) => {
  return axios.post(API_URL + "changesystime", {
    hours,
    minutes,
    seconds,
  });
};

const changeSysDate = (day, month, year) => {
  return axios.post(API_URL + "changesysdate", {
    day,
    month,
    year,
  });
};

//get data from Dashboardview/document(dashboardName), retrieve specific column's(columnsToRetrieve) data based on specific values(valueToMatch ) of one of the column(columnToFilter)
const getMultiColumnsRows = (
  dashboardName,
  columnsToRetrieve,
  columnToFilter,
  valueToMatch,
) => {
  return axios.post(API_URL + "multiColumnsRows", {
    dashboardName,
    columnsToRetrieve,
    columnToFilter,
    valueToMatch,
  });
};

// insert multiple document/record to existing collection/Dashboardview
const insertMultipleRow = (dashboardName, widgetConfigData) => {
  return axios.post(API_URL + "multiInsert", {
    dashboardName,
    widgetConfigData,
  });
};

const validateScript = (scriptName, script) => {
  return axios.post(API_URL + "validateScript", {
    scriptName,
    script,
  });
};

const runScript = (scriptName, script, input_vars, output_vars) => {
  return axios.post(API_URL + "runScript", {
    scriptName,
    script,
    input_vars,
    output_vars,
  });
};

// Get json payload from backend.
const getPayload = (dashboardName, keyName) => {
  return axios.post(API_URL + "getpayload", {
    dashboardName,
    keyName,
  });
};

// Get All json payload from backend.
const getAllPayload = (dashboardName) => {
  return axios.post(API_URL + "getallpayload", {
    dashboardName,
  });
};

// save json payload to backend.
const savePayload = (dashboardName, payload) => {
  return axios.post(API_URL + "savepayload", {
    dashboardName,
    payload,
  });
};

//Send File to Server
const uploadFile = (file) => {
  //console.log(file)

  const formData = new FormData();
  formData.append("file", file);

  return axios.post(API_URL + "uploadfile", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

}

//Receive File from Server
const downloadFile = (fileName) => {

  return axios.get(API_URL + "downloadfile/" + fileName, {
    responseType: "blob"
  });

}

const getFiles = () => {{
    return axios.get(API_URL + "filelist");
  }}

// Delete specific file
const deleteFile = (fileName) => {
  return axios.delete(API_URL + "deletefile/" + fileName);
};

// Delete all files
const deleteAllFiles = () => {
  return axios.delete(API_URL + "deleteallfiles");
};

// driver control 
const driverControl = (driverName, command) => {

  return axios.post(API_URL + "drivercontrol", {
    driverName,
    command,
  });
   
};

const driverStatus = (driverName) => {

  return axios.post(API_URL + "driverstatus", {
    driverName,
  });
   
};

const driverToggle = (driverName) => {

  return axios.post(API_URL + "drivertoggle", {
    driverName,
  });
   
};



// downloadLicenseRequest
const downloadLicenseRequest = (dashboardName, rowData) => {
  return axios.post(API_URL + "downloadlicenserequest", {
    dashboardName,
    rowData,
  });
};

const ConfigurationViewService = {
  getCompanyURL,
  getLoginScreenStatus,
  getDashboardList,
  getRowsCount,
  getRowsData,
  getAllRowsData,
  getColumnData,
  getSchemaKeys,
  updateRowData,
  updateTokenData,
  createRow,
  deleteRow,
  deleteManyTag,
  getIPDetails,
  changeIPDetails,
  getSysTime,
  changeSysTime,
  changeSysDate,
  deleteCollection,
  insertCollection,
  getMultiColumnsRows,
  insertMultipleRow,
  validateScript,
  runScript,
  getPayload,
  getAllPayload,
  savePayload,
  uploadFile,
  downloadFile,
  getFiles,
  deleteFile,
  deleteAllFiles,
  driverControl,
  driverStatus,
  driverToggle,
  downloadLicenseRequest,
};

export default ConfigurationViewService;
